'use client'

import Image from 'next/image'
import type {
  AbhaSuccessFeaturesBlock,
  AbhaSuccessPanelVariant,
} from '@components/NewProduct/AbhaHeroWidget/steps/abhaSuccessRightPanelTypes'
import { getClassNames } from '@helpers/productWidgetHelper'

export type AbhaHeroSuccessFeaturesProps = {
  block: AbhaSuccessFeaturesBlock
  panelVariant: AbhaSuccessPanelVariant
  isMobile?: boolean
}

export const AbhaHeroSuccessFeatures = ({ block, panelVariant, isMobile = false }: AbhaHeroSuccessFeaturesProps) => {
  if (!block.items.length) {
    return null
  }

  return (
    <div
      className={getClassNames(
        [
          'abha-hero-success-panel__features',
          isMobile ? 'abha-hero-success-panel__features--mobile' : 'abha-hero-success-panel__features--desktop',
          `abha-hero-success-panel__features--${panelVariant}`,
        ],
        {
          'abha-hero-success-panel__features--mobile-three-columns': isMobile && block.items.length === 3,
        }
      )}>
      {block.items.map((item, index) => (
        <div key={`${item.text}-${index}`} className="abha-hero-success-panel__feature">
          <Image
            src={item.icon}
            alt=""
            width={isMobile ? 40 : 36}
            height={isMobile ? 40 : 36}
            className="abha-hero-success-panel__feature-icon"
            aria-hidden
          />
          <p className="abha-hero-success-panel__feature-text">{item.text}</p>
        </div>
      ))}
    </div>
  )
}
